module.exports = "/assets/site/images/tollaslabda.jpg?33bc5ef3c74126e2a9e360399638dc9d";